import {
  SET_ACTIVE_PO,
  SET_NOT_ACTIVE_PO,
  START_LOADING,
  STOP_LOADING,
  GET_DOC_CONTROL,
  SET_PO_CONTRACT,
  GET_PO_CONTRACT,
} from "./actionTypes";
import axios from 'axios';
import { AppSettings} from '../../configs';
import { authHeader } from '../../helpers/auth-header';


export function setActivePOAction(userId,poContractNo,sessionNo){
  return function(dispatch){

    dispatch({
      type : SET_ACTIVE_PO
    })
    // try {
    //       let promise= axios({
    //           headers: authHeader(),
    //           method: "post",
    //           url: `${AppSettings.apiUrl}/api/RRS/SetActivePO`,
    //           params: {
    //             userId:userId,
    //             poContractNo:poContractNo,
    //             session:sessionNo,
    //           }
    //       })
          
    //       promise.then(response => {
    //         dispatch({
    //           type : SET_ACTIVE_PO
    //         })
    //       }
    //       );

    //       return promise
    // } 
    // catch (error) {

    // } 
    // finally {
    // }

  }
}

export function setNotActivePOAction(userId,poContractNo,sessionNo,isDelete){
  return function(dispatch){

    try {
          let promise= axios({
              headers: authHeader(),
              method: "post",
              url: `${AppSettings.apiUrl}/api/RRS/SetNotActivePO`,
              params: {
                userId:userId,
                poContractNo:poContractNo,
                session:sessionNo,
                isDelete:isDelete
              }
          })
          
          promise.then(response => {
            dispatch({
              type : SET_NOT_ACTIVE_PO
            })
          }
          );

          return promise
    } 
    catch (error) {

    } 
    finally {
    }

  }
}

export function setNotActivePOManualAction(userId,poContractNo,sessionNo,isDelete){
  return function(dispatch){

    try {
          let promise= axios({
              headers: authHeader(),
              method: "post",
              url: `${AppSettings.apiUrl}/api/RRS/SetNotActivePO`,
              params: {
                userId:userId,
                poContractNo:poContractNo,
                session:sessionNo,
                isDelete:isDelete
              }
          })
          
          promise.then(response => {
            dispatch({
              type : SET_NOT_ACTIVE_PO
            })
          }
          );

          return promise
    } 
    catch (error) {

    } 
    finally {
    }

  }
}

export function getDocControlAction(serachCondition) {
  
  return function (dispatch) {

      dispatch({
          type: START_LOADING
      })

      try {
          let promise = axios({
              headers: authHeader(),
              method: "post",
              url: `${AppSettings.apiUrl}/api/RRS/GetDocControl`,
              data: serachCondition
             
          })

          promise.then(response => {
              dispatch({
                  type: GET_DOC_CONTROL,
                  payload: response.data,
              });
              dispatch({
                  type: STOP_LOADING
              });
          }
          );

          return promise
      } catch (error) {
          dispatch({
              type: STOP_LOADING
          })

      } finally {
      }
  }
}

export function setPo_ContarctAction(po_contract_no){
  return function(dispatch){
    dispatch({
      type : SET_PO_CONTRACT,
      payload: po_contract_no,
    })
  }
}

export function getPo_ContarctAction(){
  return function(dispatch){
    dispatch({
      type : GET_PO_CONTRACT,
    })
  }
}